import { j as t } from "./atoms-v218.js";
import { useState as Y } from "react";
import { CalendarMonth as m } from "./atoms-v2765.js";
import { useCalendarContext as p } from "./atoms-v2766.js";
import { Wrapper as x } from "./atoms-v2770.js";
import { useDataPreloader as j } from "./atoms-v2769.js";
function y({ colorTheme: o = "light" }) {
  const { domBuilder: e, userInteractions: i } = p(), [r, l] = Y(() => {
    if (i.startingCell) {
      const n = new Date(i.startingCell), h = n.getFullYear(), v = n.getMonth();
      return e.calendarYearConfigs.find(
        (f) => f.value === h && f.month.value === v
      ) ?? e.calendarYearConfigs[0];
    }
    return e.calendarYearConfigs[0];
  }), s = r.value, C = r.month.value, a = e.calendarYearConfigs.findIndex(
    (n) => n.value === s && n.month.value === C
  ), d = a > 0, c = a < e.calendarYearConfigs.length - 2, u = e.calendarYearConfigs[a + 1], g = u.value;
  return j(), /* @__PURE__ */ t.jsxs(x, { "aria-label": "Calendar", children: [
    /* @__PURE__ */ t.jsx(
      m,
      {
        hideNextButton: !0,
        colorTheme: o,
        monthConfig: r.month,
        onPreviousClick: d ? () => {
          d && l(e.calendarYearConfigs[a - 1]);
        } : void 0,
        yearValue: s
      }
    ),
    /* @__PURE__ */ t.jsx(
      m,
      {
        hidePreviousButton: !0,
        colorTheme: o,
        monthConfig: u.month,
        onNextClick: c ? () => {
          c && l(e.calendarYearConfigs[a + 1]);
        } : void 0,
        yearValue: g
      }
    )
  ] });
}
export {
  y as CalendarPair
};
